<template>
    <div v-if="loading || sponsors.length > 0">
        <!-- Title Section -->
        <div v-if="loading" class="tw-flex tw-justify-center tw-mb-4">
            <div class="tw-h-6 md:tw-h-8 tw-bg-gray-100 tw-rounded tw-w-32 tw-animate-pulse"></div>
        </div>
        <div v-else>
            <h1 class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold tw-text-center">Sponsors</h1>
        </div>

        <!-- Loading State with Skeleton -->
        <div v-if="loading" class="tw-flex tw-justify-center tw-items-center tw-gap-6 tw-mt-4 tw-flex-wrap">
            <div v-for="n in 6" :key="n" class="tw-animate-pulse">
                <div class="tw-w-24 tw-h-24 tw-bg-gray-200 tw-rounded-full"></div>
            </div>
        </div>

        <!-- Actual Content -->
        <div v-else class="tw-flex tw-justify-center tw-items-center tw-gap-6 tw-mt-4 tw-flex-wrap tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-p-2">
            <div v-for="sponsor in sponsors" :key="sponsor.id" class="tw-w-24 tw-h-24 tw-rounded-full tw-overflow-hidden tw-border tw-border-solid tw-border-gray-200">
                <img :src="sponsor.image" class="tw-w-full tw-h-full tw-object-contain" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { all } from '@/api/sponsors';
import { ref } from 'vue';

const sponsors = ref([]);
const loading = ref(true);


const getSponsors = async () => {
    loading.value = true;
    await all()
    .then(
        res => {
            console.log(res.data);
            sponsors.value = res.data;
        }
    )
    .catch(
        err => {
            console.log(err);
        }
    )
    loading.value = false;
};
    
getSponsors();
</script>

<style scoped>

</style>